import React, { Component } from 'react';

import VerifyCodeView from '../components/2fa/VerifyCodeView';
import { LoginContext } from '../contexts/LoginContext';

class VerifyCodeContainer extends Component {
    render() {
        const {
            errorMessage,
            loading,
            onTwoFactorCodeChange,
            onTwoFactorToggleRememberBrowser,
            onVerifyTwoFactorCode,
            twoFactorActiveProvider,
            twoFactorCode,
            twoFactorRememberBrowser,
        } = this.context;
        return (
            <VerifyCodeView
                activeProvider={twoFactorActiveProvider}
                code={twoFactorCode}
                errorMessage={errorMessage}
                loading={loading}
                onCodeChange={onTwoFactorCodeChange}
                onToggleRememberBrowser={onTwoFactorToggleRememberBrowser}
                onVerifyCode={onVerifyTwoFactorCode}
                rememberBrowser={twoFactorRememberBrowser}
            />
        );
    }
}

VerifyCodeContainer.contextType = LoginContext;

export default VerifyCodeContainer;
